import { createSlice } from "@reduxjs/toolkit";

export const identifySlice = createSlice({
    name: "identifyOptions",
    initialState: {
        open: false,
        buffer: false,
        units: "Feet",
        distance: 100,
        activeIdentifyTool: "",
        featuresToBuffer: [],
        bufferToDrawingLayer: false,
    },
    reducers: {
        setBufferOptions: (state, action) => {
            state.open = action.payload;
        },
        setBufferState: (state, action) => {
            state.buffer = action.payload;
        },
        setBufferUnits: (state, action) => {
            state.units = action.payload;
        },
        setBufferDistance: (state, action) => {
            state.distance = action.payload;
        },
        setActiveIdentifyTool: (state, action) => {
            state.activeIdentifyTool = action.payload;
        },
        setFeaturesToBuffer: (state, action) => {
            state.featuresToBuffer = action.payload;
        },
        // when continue is clicked bufferFeatures is set to true
        //  & feature(s) is/are buffered on map
        setBufferFeature: (state, action) => {
            state.bufferFeature = action.payload;
        },
        setBufferToDrawingLayer: (state, action) => {
            state.bufferToDrawingLayer = action.payload;
        },
    },
});

export const {
    setBufferOptions,
    setBufferDistance,
    setBufferState,
    setBufferUnits,
    setActiveIdentifyTool,
    setBufferFeature,
    setFeaturesToBuffer,
    setBufferToDrawingLayer,
} = identifySlice.actions;
export default identifySlice.reducer;
